import React from "react";
import { dateToString } from "../../libs/helpers";
import DateSelect from "./DateSelect";


const DateCell: React.FC<DateCellProps> = (props: DateCellProps) => {
  const { isConfirmed, onChangeDate, value } = props;
  return (
    <div style={{minWidth: "122px"}}>
      {
        isConfirmed ? 
          <span>{dateToString(value)}</span> :
          <DateSelect
            selectedDate={new Date(value)}
            handleDateChange={(date) => onChangeDate(date)}
          />
      }
    </div>
  )
}

export default DateCell;

export type DateCellProps = {
  isConfirmed: boolean;
  value: string;
  onChangeDate: (val: Date | null) => void;
}